module.exports = __webpack_public_path__ + "static/media/logs_selected.fe54363a.svg";